import React  from 'react';
import Popup from '../popups/popup';
import I18n from 'lib/i18n/i18n';
import { connect } from "react-redux";
import { MediumPrimaryButton, MediumLinkButton } from '@worthy-npm/clarity';
import UserActions from "lib/userActions";
import {bindActionCreators} from "redux";
import {requestShippingKit} from "../../actions/shipment";
import Listing from "../listing/listing";
import {requestShippingKitPopupText} from "../../helpers/ApplicationHelper";

class PopupRequestShippingKitExperiment extends Popup {
    static initPopup(props = {}) {
        props.preventLocationBack = true;
        Popup.initPopup.call(this, props);
    }

    title() {
        return I18n.getString('shippingKit::popup::headline');
    }

    requestShippingKit = (stopAnimation) => {
        const { item, experiments } = this.props;
        const { onSuccess } = this.props;
        const that = this;

        UserActions.listingPage('Get shipping kit - approved', item.id, Listing.getVersion(this.props));
        return this.props.requestShippingKit(item.id).then(data => {
            if (onSuccess) {
                onSuccess();
            }
            stopAnimation();
            that._hide(true);
        }).catch(err => {
            this.toggleInnerPopup();
            stopAnimation();
            that._hide(true);
        });
    }

    _onPopupClose() {

    }

    hidePopup = () => {
        const { item } = this.props;
        UserActions.listingPage('Get shipping kit - canceled', item.id, Listing.getVersion(this.props));
        this._hide();
    }

    content() {
        const {
            item
        } = this.props;

        return (
            <div className='shipping-kit-popup'>
                <p dangerouslySetInnerHTML={{ __html: requestShippingKitPopupText(item.shipment.shipment_method) }}/>
                <div className='shipping-kit-popup-button-wrap' data-automation='get-shipping-kit-btn'>
                    <MediumPrimaryButton text={I18n.getString('shippingKit::popup::approveButton') } disabled={false} click={(stopAnimation) => this.requestShippingKit(stopAnimation)} />
                </div>
                <div className='shipping-kit-popup-button-wrap'>
                    <MediumLinkButton text={I18n.getString('shippingKit::popup::declineButton') } click={() => this.hidePopup()}/>
                </div>
            </div>
        );
    }
}

PopupRequestShippingKitExperiment.defaultProps = {
    popupClassName: 'popup-shipping-kit-request',
    onSuccess: () => {},
    single: true,
    modal: true,
    onPopupClose: function() {
        this._onPopupClose();
    }
};

const mapStateToProps = ({ Item, Experiments, ADO, Personalized }) => {
    return {
        item: Item,
        ADO,
        experiments: Experiments,
        P13N: Personalized,
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ requestShippingKit }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(PopupRequestShippingKitExperiment);
